import HealthCareWhatWeDo from "../components/newComponents/healthCareWhatWeDo/healthCareWhatWeDo"
import CliensPartners from "../components/newComponents/cliensPartners/cliensPartners"
import BusinessForm from "../components/newComponents/businessForm/businessForm"
import CaseStudies from "../components/newComponents/caseStudies/caseStudies"
import OurAlliance from "../components/newComponents/ourAlliance/ourAlliance"
import MainBanner from "../components/newComponents/mainBanner/mainBanner"
import Techstacks from "../components/newComponents/techstacks/techstacks"
import Expertise from "../components/newComponents/expertise/expertise"
import WhyAgile from "../components/newComponents/whyAgile/whyAgile"
import Overview from "../components/newComponents/overView/overview"
import Benefits from "../components/newComponents/benefits/benefits"
import { useHomeNewMetadata } from "../queries/useHomeNewMetaData"
import Footer from "../components/newComponents/footer/footer"
import Guide from "../components/newComponents/guide/guide"
import HowWeDo from "../components/newComponents/howWeDo"
import Blog from "../components/newComponents/blog/blog"
import Faq from "../components/newComponents/faq/faq"
import Cta from "../components/newComponents/CTA/cta"
import Header from "../components/header/header"
import React, { useEffect } from "react"
import parse from "html-react-parser"
import Seo from "../components/seo"
import { Schema } from "../schema"
import { graphql } from "gatsby"

const ItConsultingServices = ({ data }) => {
  const newHomeData = useHomeNewMetadata()

  const {
    homeTechShowSection,
    homeTechContent,
    homeTechTitle,
    homeTechSubTitle,

    homeWorkContent,
    homeNewWorkLogoList,
    homeWorkShowSection,
    homeWorkSubTitle,
    homeWorkTitle,

    faqSmallContent,
    faqButtonText,
    faqButtonLink,

    homeAllianceSection,
    homeNewAllianceImageList,
    homeAllianceTitle,
    homeAllianceContent,
    homeAllianceSubTitle,

    homeWhyContent,
    homeWhyTitle,
    homeWhyShowSection,
    homeWhySubTitle,
    homeWhyAgileContect,
    homeNewWhyIconTextList,
    homeWhyVideoUrl,

    homeDomainTitle,
    homeDomainContent,
    homeDomainShowSection,
    homeDomainSubTitle,
    homeNewDomainImageTextList,

    homeCaseContent,
    homeCaseTitle,
    homeCaseShowSection,
    homeCaseSubTitle,

    homeBlogContent,
    homeBlogTitle,
    homeBlogShowSection,
    homeBlogSubTitle,

    technologyStack,
  } = newHomeData?.wpPage?.homePageNewFields

  // service data
  const {
    bannerBackgroundImage,
    bannerButtonText,
    bannerShowSection,
    bannerTitle,
    bannerButtonLink,

    overviewContent,
    overviewShowSection,
    overviewTag,
    overviewTitle,

    serviceTitle,
    serviceTag,
    serviceShowSection,
    serviceShortDescription,
    servicesImageContentList,

    selectBlogs,

    selectTechstackServices,
    techStackServicesShowSection,
    selectCaseStudies,

    showOverviewImage,
    overviewImage,

    cta1ShowSection,
    cta1Tag,
    cta1Title,
    cta1Cta,

    discoverMvpImage,

    serviceFaqTitle,
    serviceFaqSubTitle,
    serviceFaqContent,
    servicesFaqQuestionAnswersList,
    serviceFaqSchema,

    userGuideShowSection,
    userGuideTitle,
    userGuideSubtitle,
    userGuideContent,
    servicesListOfUserGuide,

    benefitsContent,
    benefitsShowSection,
    benefitsSubtitle,
    benefitsTitle,
    benefitList,

    bannerContent,
    bannerSubTitle,
    serviceFaqShowSection,
    workflowShowSection,
    workTitle,
    workSubtitle,
    workFlowList,
    workContent,
  } = data?.wpPage?.serviceNewPageFields
  
  const { seo } = newHomeData?.wpPage

  const schema = Schema
  let customSchema = parse(`${data?.wpPage?.MetaFields?.customPageSchema}`)

  useEffect(() => {
    localStorage.removeItem("casepage")
    localStorage.removeItem("blogpage")
  }, [])

  let faqSchema = parse(`${serviceFaqSchema}`)

  return (
    <>
      <Seo
        title={seo?.title}
        seoData={data?.wpPage?.MetaFields}
        schemaMarkup={schema}
        customPageSchema={customSchema}
        faqSchema={faqSchema}
        bannerImage={bannerBackgroundImage?.mediaItemUrl}
      />
      <Header homeData={newHomeData?.wp} />

      <MainBanner
        homeBannerTitle={bannerTitle}
        homeBannerSubTitle={bannerSubTitle}
        homeBannerContent={bannerContent}
        homeBannerButtonText={bannerButtonText}
        homeBannerButtonLink={bannerButtonLink}
        homeBannerShowSection={bannerShowSection}
        homeBannerBackgroundImage={bannerBackgroundImage}
      />

      <Overview
        overviewTag={overviewTag}
        overviewContent={overviewContent}
        overviewShowSection={overviewShowSection}
        overviewTitle={overviewTitle}
        showOverviewImage={showOverviewImage}
        overviewImage={overviewImage}
      />

      <HealthCareWhatWeDo
        serviceTitle={serviceTitle}
        serviceTag={serviceTag}
        serviceShowSection={serviceShowSection}
        serviceShortDescription={serviceShortDescription}
        serviceImageContentList={servicesImageContentList}
        isCollapse="yes"
      />

      <Cta
        cta1Tag={cta1Tag}
        cta1Title={cta1Title}
        discoverMvpImage={discoverMvpImage}
        cta1Cta={cta1Cta}
        cta1ShowSection={cta1ShowSection}
      />

      <HowWeDo
        sectionTitle={workTitle}
        sectionSubTitle={workSubtitle}
        sectionContent={workContent}
        showSection={workflowShowSection}
        listItems={workFlowList}
      />

      <Expertise
        homeDomainTitle={homeDomainTitle}
        homeDomainContent={homeDomainContent}
        homeDomainShowSection={homeDomainShowSection}
        homeDomainSubTitle={homeDomainSubTitle}
        homeDomainImageTextList={homeNewDomainImageTextList}
      />

      <Benefits
        benefitsShowSection={benefitsShowSection}
        benefitsContent={benefitsContent}
        benefitsTitle={benefitsTitle}
        benefitsSubTitle={benefitsSubtitle}
        benefitList={benefitList}
      />

      <Techstacks
        homeTechContent={homeTechContent}
        homeTechTitle={homeTechTitle}
        techStackShowSection={techStackServicesShowSection}
        homeTechSubTitle={homeTechSubTitle}
        selectTechstack={selectTechstackServices}
        technologyStack={technologyStack}
        type="pagewise"
      />

      <CaseStudies
        homeCaseContent={homeCaseContent}
        homeCaseTitle={homeCaseTitle}
        homeCaseShowSection={homeCaseShowSection}
        homeCaseSubTitle={homeCaseSubTitle}
        selectCaseStudies={selectCaseStudies}
        CustomClass="casestudies-section"
      />

      <WhyAgile
        homeWhyContent={homeWhyContent}
        homeWhyTitle={homeWhyTitle}
        homeWhyShowSection={homeWhyShowSection}
        homeWhySubTitle={homeWhySubTitle}
        homeWhyIconTextList={homeNewWhyIconTextList}
        homeWhyAgileContect={homeWhyAgileContect}
        homeWhyVideoUrl={homeWhyVideoUrl}
      />

      <Guide
        serviceListOfUserGuide={servicesListOfUserGuide}
        userGuideContent={userGuideContent}
        userGuideShowSection={userGuideShowSection}
        userGuideSubTitle={userGuideSubtitle}
        userGuideTitle={userGuideTitle}
      />

      <Techstacks
        homeTechContent={homeTechContent}
        homeTechTitle={homeTechTitle}
        homeTechShowSection={homeTechShowSection}
        homeTechSubTitle={homeTechSubTitle}
        technologyStack={newHomeData?.allWpTechnologyStack}
        technologyStackCategory={newHomeData?.allWpTechnologyStackCategory}
      />

      <Blog
        homeBlogContent={homeBlogContent}
        homeBlogTitle={homeBlogTitle}
        selectBlog={selectBlogs}
        homeBlogShowSection={homeBlogShowSection}
        homeBlogSubTitle={homeBlogSubTitle}
      />

      <CliensPartners
        homeWorkContent={homeWorkContent}
        homeWorkLogoList={homeNewWorkLogoList}
        homeWorkShowSection={homeWorkShowSection}
        homeWorkSubTitle={homeWorkSubTitle}
        homeWorkTitle={homeWorkTitle}
      />

      <Faq
        faqContent={serviceFaqContent}
        faqShowSection={serviceFaqShowSection}
        faqSubTitle={serviceFaqSubTitle}
        faqTitle={serviceFaqTitle}
        faqSmallContent={faqSmallContent}
        faqButtonText={faqButtonText}
        faqButtonLink={faqButtonLink}
        faqQuestionAnswerList={servicesFaqQuestionAnswersList}
      />

      <BusinessForm homeData={newHomeData?.wp} />

      <OurAlliance
        homeAllianceSection={homeAllianceSection}
        homeAllianceImageList={homeNewAllianceImageList}
        homeAllianceTitle={homeAllianceTitle}
        homeAllianceContent={homeAllianceContent}
        homeAllianceSubTitle={homeAllianceSubTitle}
      />

      <Footer
        footerMenu={newHomeData?.wpMenu?.menuItems}
        homeData={newHomeData?.wp?.myThemeOptionsSettings}
      />
    </>
  )
}

export default ItConsultingServices

export const query = graphql`
  query ServiceData($slug: String) {
    wpPage(slug: { eq: $slug }) {
      slug
      title
      id
      uri
      serviceNewPageFields {
        workflowShowSection
        workTitle
        workSubtitle
        workFlowList {
          workFlowIcon
          workFlowTitle
        }
        workContent
        benefitsContent
        benefitsShowSection
        benefitsSubtitle
        benefitsTitle
        benefitList {
          benefitsListIcon
          benefitsListContent
          benefitsListTitle
        }
        bannerButtonLink {
          url
        }
        bannerContent
        bannerSubTitle
        serviceFaqSchema
        bannerBackgroundImage {
          altText
          mediaItemUrl
        }
        bannerButtonLink {
          target
          title
          url
        }
        selectBlogs {
          ... on WpPost {
            id
            categories {
              nodes {
                name
              }
            }
            singlePageFieldsNew {
              viewsCountShowSection
              viewsCount
              authorDesignation
              authorName
              showAuthor
              authorImage {
                mediaItemUrl
                altText
              }
            }
            featuredImage {
              node {
                mediaItemUrl
                altText
              }
            }
            date
            content
            title
            slug
          }
        }
        cta1ShowSection
        cta1Tag
        cta1Title
        cta1Cta {
          title
          url
        }
        cta2ShowSection
        cta2Tag
        cta2Title
        cta2Cta {
          title
          url
        }
        cta3ShowSection
        cta3Title
        cta3Content
        cta3Cta {
          title
          url
        }
        discoverMvpShowSection
        discoverMvpTag
        discoverMvpTitle
        discoverMvpImage {
          altText
          mediaItemUrl
        }
        discoverMvpCta {
          title
          url
        }
        bannerButtonText
        bannerShowSection
        bannerTitle
        bannerVideoLink {
          altText
          mediaItemUrl
        }
        caseShowSection
        selectCaseStudies {
          ... on WpCaseStudy {
            id
            title
            slug
            featuredImage {
              node {
                mediaItemUrl
                altText
              }
            }
            content
            CaseStudiesPostFieldsNew {
              caseIndustryTag
              caseSolutionTag
              caseSolution
              caseIndustry
              caseTitle
              caseSubTitle
              caseCountry
              portfolioDarkColorCode
              portfolioLightColorCode
              portfolioTextColorCode
              portfolioParentClassName
            }
          }
        }
        selectTestimonials {
          ... on WpTestimonial {
            id
            title
            featuredImage {
              node {
                mediaItemUrl
                altText
              }
            }
            TestimonialsField {
              country
              feedback
              position
              videoLink {
                altText
                mediaItemUrl
              }
              pageLink
            }
          }
        }
        videoShowSection
        videoSectionUrl {
          altText
          mediaItemUrl
        }
        testimonialsShowSection
        techStackServicesShowSection
        selectTechstackServices {
          ... on WpTechnologyStackServices {
            id
            title
            slug
            TechnologyStackPostFields {
              technologyStackIcon
              fieldGroupName
            }
            contentTypeName
          }
        }
        serviceTitle
        serviceTag
        serviceShowSection
        serviceShortDescription
        servicesImageContentList {
          serviceListTitle
          fieldGroupName
          serviceListContent
          hasListPoints
          serviceListImage
          listPoints {
            fieldGroupName
            shortDescription
            title
          }
        }
        overviewTitle
        overviewTag
        overviewShowSection
        overviewContent
        overviewImage {
          altText
          mediaItemUrl
        }
        showOverviewImage
        serviceFaqTitle
        serviceFaqSubTitle
        serviceFaqContent
        servicesFaqQuestionAnswersList {
          faqListQuestion
          faqListAnswer
        }
        selectBlogs {
          __typename
        }
        serviceFaqShowSection
        userGuideShowSection
        userGuideTitle
        userGuideSubtitle
        userGuideContent
        servicesListOfUserGuide {
          userGuideTabTitle
          userGuideTabRoleText
          userGuideTabContent
          userGuideTabListing {
            userGuideTabMainText
            userGuideTabSubText
          }
        }
      }
      MetaFields {
        customPageSchema
        customSeoFocusKeyphrase
        customSeoKeywords
        customSeoMetaDescription
        customSeoMetaTitle
        customSeoRobotFollow
        customSeoRobotIndex
        fieldGroupName
        customSeoOgUrl
      }
    }
    allWpTechnologyStackServices(sort: { date: DESC }) {
      edges {
        node {
          id
          title
          link
          TechnologyStackPostFields {
            technologyStackIcon
          }
        }
      }
    }
  }
`
